import React from "react"
import { Link } from "gatsby"

import { URLS } from "@data"
import { Analytics } from "@shared"
import { css, featureFlag } from "@jsUtils"

const AnalyticsLink = Analytics(Link)

/**
 * Main Navigation items
 * Re-used by the footer
 * @param {object} - props - react props
 * @param {boolean} - props.hidden - hidden from screen readers
 * @param {string} - props.className - css class name
 */
const NavMain = ({ analytics, hidden, className, linkStyleMap }) => {
  const { exo, vis, tech } = linkStyleMap
  const tabbing = hidden ? -1 : 0

  const animationSequence = []
  // Set the loop terminus high enough to handle max list items
  for (let i = 1; i < 30; i++) {
    animationSequence.push(i)
  }

  return (
    <ul className={className} aria-hidden={hidden}>
      <li style={{ "--animation-position": animationSequence.shift() }}>
        <AnalyticsLink
          ascope={analytics}
          adata="NAV.EXO"
          to={URLS.EXO_WORKS}
          tabIndex={tabbing}
          className={css(exo)}
        >
          Exo Works
        </AnalyticsLink>
      </li>
      <li style={{ "--animation-position": animationSequence.shift() }}>
        <AnalyticsLink
          ascope={analytics}
          adata="NAV.VISION"
          to={URLS.VISION}
          tabIndex={tabbing}
          className={css(vis)}
        >
          Vision
        </AnalyticsLink>
      </li>
      {featureFlag("link.technology") && (
        <li style={{ "--animation-position": animationSequence.shift() }}>
          <AnalyticsLink
            ascope={analytics}
            adata="NAV.TECH"
            to={URLS.TECHNOLOGY}
            className={css(tech)}
            tabIndex={tabbing}
          >
            Technology
          </AnalyticsLink>
        </li>
      )}
    </ul>
  )
}

export default NavMain
